<template>
    <div>
        <refresh :on-refresh="refresh" :refreshing="refreshing"></refresh>
        <loading :loading="loading"></loading>

        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <Logo :logo-type="theType" />
                <div class="msg-title">
                    Your Message History with
                </div>
                <ion-chip v-on:click="viewUser()">
                    <ion-avatar>
                        <img :src="sender.avatar" v-if="sender.avatar">
                        <img src="../../assets/ghost-avatar-white-thumb.png" class="dark-img" v-else>
                    </ion-avatar>
                    <ion-label>
                        {{sender.name}}
                    </ion-label>
                </ion-chip>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6" v-if="noMessages">
                You have no messages from {{sender.name}}
            </div>
            <div class="col-12 col-xs-12 col-md-6" v-else>
                <div v-for="message in messages" v-bind:key="message.id" class="bubble-wrap">
                    <div class="bubble-talker">
                        <ion-avatar v-on:click="viewUser()">
                            <img :src="sender.avatar" v-if="sender.avatar">
                            <img src="../../assets/ghost-avatar-white-thumb.png" class="dark-img" v-else>
                        </ion-avatar>
                    </div>
                    <div class="bubble-chat">
                        <ion-card-header>
                            <ion-card-subtitle style="text-align: right; color: var(--ion-color-primary);">
                                {{dateFormat(message.message.send_at, 'Do MMMM YYYY')}}
                            </ion-card-subtitle>
                        </ion-card-header>
                        <ion-card-content style="padding-top: 0;">
                            <div style="text-align: left; padding-bottom: 1rem;">
                                {{message.message.title}}<br>
                            </div>
                            <div v-html="nl2br(message.message.message)" style="text-align: left;"></div>
                            <div v-if="!message.viewed_at" v-observe-visibility="(isVisible, entry) => viewed(isVisible, entry, message)"></div>
                        </ion-card-content>
                    </div>
                </div>
                <ion-infinite-scroll @ionInfinite="loadMore" threshold="100px" position="bottom">
                    <ion-infinite-scroll-content loading-spinner="dots"></ion-infinite-scroll-content>
                </ion-infinite-scroll>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-xs-12 col-md-4">
                <div class="router-nav u-mt2 u-mb2">
                    <ion-button shape="round" expand="full" v-on:click="back()">Return</ion-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {auth} from '@/mixins/auth';
import {userdetails} from '@/mixins/userdetails';
import {formatting} from '@/mixins/formatting';
import ReturnHome from '@/components/ReturnHome.vue';
import Refresh from '@/components/Refresh.vue';
import Loading from '@/components/Loading.vue';
import Logo from '@/components/Logo.vue';
import _ from 'lodash';

export default {
    name: 'messages',
    mixins : [auth, userdetails, formatting],
    components : {
        ReturnHome, Logo, Refresh, Loading
    },
    data : function () {
        return {
            theType : 'text',
            sender  : {
                id   : 0,
                name : 'this person',
            },
            messages : [],
            page     : 1,
            complete : false,
            loading  : false,
            refreshing : false
        };
    },
    mounted : function () {
        this.getSender();
        this.getMessages();
    },
    computed : {
        typeTitle : function () {
            if (this.theType == 'audio') { return 'Calls'; }
            if (this.theType == 'video') { return 'Videos'; }
            if (this.theType == 'image') { return 'Gallery'; }
            return 'Messages';
        },
        typeDesc : function () {
            if (this.theType == 'audio') { return 'calls'; }
            if (this.theType == 'video') { return 'videos'; }
            if (this.theType == 'image') { return 'photos'; }
            return 'messages';
        },
        noMessages : function () {
            return _.size(this.messages) == 0;
        }
    },
    methods : {
        refresh : function () {
            this.refreshing = true;
            this.page = 1;
            this.getMessages();
        },
        hideLoading : function () {
            this.loading = false;
            this.refreshing = false;
            console.log('[MESSAGES]', this.messages);
        },
        loadMore : function (event) {
            console.log('loading messages', event);
            this.getMessages();
            event.target.complete();
        },
        getSender : function () {
            let self = this;
            this.axios.get(this.api + 'messages/sender/' + this.$route.params.id)
                .then(response => {
                    self.sender = response.data;
                    self.hideLoading();
                })
                .catch(error => {
                    console.error('Error getting sender', error);
                    this.$router.push({name : 'messages'});
                });
        },
        getMessages : function () {
            let self = this;
            console.log('getting messages', this.complete);
            if (this.complete) {
                this.hideLoading();
                return;
            }
            this.loading = true;
            this.axios.get(this.api + 'messages/inbox/' + this.theType + '/senders/' + this.$route.params.id + '?page=' + this.page)
                .then(response => {
                    if (self.refreshing) {
                        self.messages = [];
                        self.refreshing = false;
                    }

                    var messages = _.reverse(_.sortBy(response.data, ['send_at']));
                    self.hideLoading();

                    if (_.size(messages) > 0) {
                        _.each(messages, function (message) {
                            self.messages.push(message);
                        });
                        self.page = self.page + 1;
                    } else {
                        self.complete = true;
                    }
                })
                .catch(error => {
                    console.error('Error getting messages', error);
                    self.hideLoading();
                });
        },
        viewed : function (isVisible, entry, message) {
            console.log('MESSAGE', message);
            if (isVisible && !message.viewed_at) {
                this.axios.post(this.api + 'messages/' + message.message_id + '/viewed')
                    .then(() => {
                        message.viewed_at = true;
                    })
                    .catch(error => {
                        console.error('Error setting message as viewed', error);
                    });
            }
        },
        viewUser : function () {
            console.log('routing to user', this.$route.params.id);
            console.log('routing to sender', this.sender);
            this.$router.push({name : 'user', params : {id : this.$route.params.id}});
        },
        back : function () {
            this.$router.push({name : 'messages'});
        }
    }
}
</script>